import { Component, OnInit } from '@angular/core';
import { ViewController, Platform, NavController, NavParams } from 'ionic-angular';
import { Localization } from '../../app/app.localization'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'custom-modal',
    templateUrl: 'custom-modal.html',
})

export class CustomModalComponent implements OnInit {
    title: string;
    subTitle: string;
    subTitles: string[];
    message: string;
    topCloseButton: boolean;
    bottomButton: string;
    bottomOkCancel: boolean;
    customHtmlCode: SafeHtml;
    paymentModules: any;

    constructor(
        public platform: Platform,
        public navCtrl: NavController,
        public viewCtrl: ViewController,
        public navParams: NavParams,
        private _loc: Localization,
        private sanitizer: DomSanitizer
    ) {
        this.title = navParams.get('title') ? navParams.get('title') : "";
        this.subTitle = navParams.get('subTitle') ? navParams.get('subTitle') : "";
        this.message = navParams.get('message') ? navParams.get('message') : "";
        this.subTitles = navParams.get('subTitles') ? navParams.get('subTitles') : null;
        this.topCloseButton = navParams.get('topCloseButton') ? true : false;
        this.bottomButton = navParams.get('bottomButton') ? navParams.get('bottomButton') : "";
        this.bottomOkCancel = navParams.get('bottomOkCancel') ? true : false;
        this.customHtmlCode = navParams.get('customHtmlCode') ? sanitizer.bypassSecurityTrustHtml(navParams.get('customHtmlCode')) : "";
        this.paymentModules = navParams.get('paymentModules') ? navParams.get('paymentModules') : "";
    }

    closeModal(data: any) {
        this.viewCtrl.dismiss(data);
    }

    ngOnInit() {
    }
}



// WEBPACK FOOTER //
// ./src/components/custom-modal/custom-modal.ts